import React, { useEffect } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { autoRefreshOrganizations } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";

function AutoRefreshOrganization(props: any) {
  const dispatch = useAppDispatch();
  const autoRefreshState = useSelector((state: RootState) => state.OrganizationsPageState.autoRefreshOrganizationState);

  useEffect(() => {
    dispatch(autoRefreshOrganizations({}));
  }, [autoRefreshState.autoRefresh]);

  return null;
}

export default AutoRefreshOrganization;
